import { render, staticRenderFns } from "./AboutBalkam.vue?vue&type=template&id=23f2e7a6&scoped=true&"
import script from "./AboutBalkam.vue?vue&type=script&lang=js&"
export * from "./AboutBalkam.vue?vue&type=script&lang=js&"
import style0 from "./AboutBalkam.vue?vue&type=style&index=0&id=23f2e7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2e7a6",
  null
  
)

export default component.exports